import { AiOutlinePauseCircle, AiOutlinePlayCircle } from 'react-icons/ai';
import styled from 'styled-components';

export const PresentationButton = styled.button`
  margin-top: 0px;
  background-color: ${({ theme }) => theme.colors.v2_secondary};
  border-radius: 50%;
  padding: 0.5rem;
  height: auto;
  width: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const IconStart = styled(AiOutlinePlayCircle)`
  height: 100%;
  width: 100%;
`;

export const IconStop = styled(AiOutlinePauseCircle)`
  height: 100%;
  width: 100%;
`;
